import React from "react";
import Spinner from "react-bootstrap/esm/Spinner";
import styles from "./AppSpinner.scss";

export type AppSpinnerProps = {
  animation?: "grow" | "border";
  small?: boolean;
  className?: string;
};

const AppSpinner = ({ animation, small, className }: AppSpinnerProps) => {
  return (
    <div className={className ? className : styles.AppSpinner}>
      <Spinner size={small ? "sm" : undefined} animation={animation || "grow"} />
    </div>
  );
};

export default AppSpinner;
